import React from 'react';
import { observer } from 'mobx-react';
import ModalStore, { DialogActionType } from '@app/src/common/store/ModalStore';

import './ModalList.scss';

const ModalList = () => {
  const onClose = (dialogActionType = DialogActionType.cancel, data?: any) =>
    ModalStore.closeModal(dialogActionType, data);

  const onCancel = () => ModalStore.closeModal(DialogActionType.cancel);
  const onSubmit = (data?: any) => ModalStore.closeModal(DialogActionType.submit, data);

  return (
    <>
      {
        ModalStore.modalList.map(modal => {
          const ModalComponent = modal.Component;
          return (
            <ModalComponent
              key={modal.id}
              onClose={onClose}
              onSubmit={onSubmit}
              onCancel={onCancel}
              {...modal.props}
            />
          );
        })
      }
    </>
  );
};

export default observer(ModalList);
